import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    state  : false,
    options: {
        anchorOrigin    : {
            vertical  : 'top',
            horizontal: 'center'
        },
        autoHideDuration: 6000,
        message         : '',
        variant         : null,
    },
};

const toastSlice = createSlice({
    name        : 'toast',
    initialState: {...initialState},
    reducers    : {
        openToast : (state, action) => {
            state.state = true;
            state.options = {...initialState.options, ...action.payload};
        },
        closeToast: (state, action) => {
            state.state = false;
        },
    },
});

export const {openToast, closeToast} = toastSlice.actions;

export const selectToastState = ({toast}) => toast.state;

export const selectToastOptions = ({toast}) => toast.options;

export default toastSlice.reducer;
